import customerCreateComponent from './customer.create.component';
import './customer.create.scss'

let customerCreateModule = angular.module('customercreate', [
  ])

  .component('customercreate', customerCreateComponent)

  .name;

export default customerCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/create/index.js